import { useAuth, overrideConfig } from '@/api/hyper-common'

const fetchOpenApiKeyStatus = function (serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.get('/v1/hyper-common/open-api/status')
}

const createOpenApiKey = function (serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.post('/v1/hyper-common/open-api')
}

const deleteOpenApiKey = function (serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.delete('/v1/hyper-common/open-api')
}
const updateSyncAccount = function (serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.put('/v1/hyper-common/open-api/account-refresh')
}
const updatePeriodExtension = function (serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.put('/v1/hyper-common/open-api/extension')
}

const fetchOpenApiDailyUsage = function (serviceIdx, { userIdx, month }) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.get(`/v1/hyper-common/open-api/users/${userIdx}/months/${month}`)
}

const fetchOpenApiLatestMonthUsage = function (serviceIdx, { userIdx }) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.get(`/v1/hyper-common/open-api/users/${userIdx}/latest/year`)
}

export default {
    fetchOpenApiKeyStatus,
    createOpenApiKey,
    deleteOpenApiKey,
    updateSyncAccount,
    updatePeriodExtension,
    fetchOpenApiDailyUsage,
    fetchOpenApiLatestMonthUsage
}
